import React from "react";

interface IGlobalSharingHeaderComponentProps {
	readonly viewActionType: ViewActionType;
	readonly isReports: boolean;
}

type ViewActionType = "makePrivate" | "makeGlobal" | "modify" | "delete" | "rename" | "create";

export const GlobalSharingHeaderComponent = (props: IGlobalSharingHeaderComponentProps) => {
	const {viewActionType, isReports} = props;
	const itemType = isReports ? "Report" : "View";
	let header: string;

	switch (viewActionType) {
		case "delete":
			header = `Delete Global ${itemType}`;
			break;
		case "modify":
		case "rename":
			header = isReports ? `Edit Global ${itemType}` : `Modify Global ${itemType}`;
			break;
		case "makePrivate":
			header = isReports ? `Demote to My ${itemType}` : `Convert to Private ${itemType}`;
			break;
		case "makeGlobal":
			header = isReports ? `Promote to Global ${itemType}` : `Convert to Global ${itemType}`;
			break;
		case "create":
			header = `Create Global ${itemType}`;
			break;
		default:
			header = "";
			break;
	}

	return <span>{header}</span>;
};
